/* f3-checkout-popup.js — F3 Gear checkout-intercept upsell popup
 *
 * Intercepts clicks on:
 *   - #F3CheckoutBtn (F3 Cart Drawer Checkout link)
 *   - The /cart page checkout form submit
 *
 * If an f3_popup_offer matches the current cart and has un-added items, shows
 * the popup. Otherwise lets the checkout navigation proceed unmodified.
 *
 * Ported from GripSocks gs-checkout-popup.js (2026-06-09)
 */
(function () {
  'use strict';

  var dataEl = document.getElementById('F3CheckoutPopupData');
  if (!dataEl) return;

  var config;
  try { config = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!config || !config.enabled) return;

  config.cart_state = config.cart_state || { product_ids_in_cart: [], collection_ids_in_cart: [] };

  var popupEl = document.getElementById('F3CheckoutPopup');
  if (!popupEl) return;

  var overlayEl        = popupEl.querySelector('[data-f3-popup-overlay]');
  var panelEl          = popupEl.querySelector('.f3-checkout-popup__panel');
  var titleEl          = document.getElementById('F3CheckoutPopupTitle');
  var subtitleEl       = document.getElementById('F3CheckoutPopupSubtitle');
  var itemsContainerEl = document.getElementById('F3CheckoutPopupItems');
  var continueBtn      = document.getElementById('F3CheckoutPopupContinue');

  var maxHeightVh      = parseInt(popupEl.dataset.maxHeightVh, 10) || 90;
  var mobileBreakpoint = parseInt(popupEl.dataset.mobileBreakpoint, 10) || 480;

  var lastFocus = null;
  var _trapHandler = null;

  // ────────────────────────────────────────────────────────────────────────────
  // TRIGGER WIRING
  // ────────────────────────────────────────────────────────────────────────────

  // Cart drawer Checkout button
  document.addEventListener('click', function (e) {
    var checkoutBtn = e.target.closest('#F3CheckoutBtn');
    if (!checkoutBtn) return;
    e.preventDefault();
    maybeShowPopup();
  });

  // Standalone /cart page checkout form
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('action') !== '/cart') return;
    if (!form.querySelector('[name="checkout"]')) return;
    e.preventDefault();
    maybeShowPopup();
  }, true);

  // ────────────────────────────────────────────────────────────────────────────
  // MATCH RESOLUTION
  // ────────────────────────────────────────────────────────────────────────────

  function maybeShowPopup() {
    var offer = resolveOffer();
    if (!offer) { proceedToCheckout(); return; }

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cartProductIds = new Set(cart.items.map(function (i) { return String(i.product_id); }));
        var visibleItems = offer.offered_items.filter(function (item) {
          return !cartProductIds.has(String(item.product_id));
        });

        if (!visibleItems.length) { proceedToCheckout(); return; }

        openPopup(offer, visibleItems);
      })
      .catch(function () { proceedToCheckout(); });
  }

  function resolveOffer() {
    // Uses Liquid-rendered cart_state for collection matching (Lesson #8 —
    // /cart.js doesn't return collection memberships). cart_state kept current
    // by f3-cart-drawer.js passing re-rendered section HTML to
    // F3CheckoutPopup.refreshCartState() after every cart mutation via SRA.
    var cartState = config.cart_state || {};
    var cartProductIds   = new Set((cartState.product_ids_in_cart   || []).map(String));
    var cartCollectionIds = new Set((cartState.collection_ids_in_cart || []).map(String));

    var offers = config.offers || [];
    for (var i = 0; i < offers.length; i++) {
      var offer = offers[i];
      if (!offer.enabled) continue;

      // An offer with NO targeting configured matches every cart (2026-06-12:
      // F3 launched with empty targeted_products/targeted_collections, so the
      // popup never fired — empty targeting now means "show for all carts").
      var hasTargeting = offer.targeted_product_ids.length > 0 ||
                         offer.targeted_collection_ids.length > 0;
      if (!hasTargeting) return offer;

      var productMatch = offer.targeted_product_ids.some(function (id) {
        return cartProductIds.has(String(id));
      });
      var collectionMatch = offer.targeted_collection_ids.some(function (id) {
        return cartCollectionIds.has(String(id));
      });

      if (!productMatch && !collectionMatch) continue;
      return offer;
    }
    return null;
  }

  // ────────────────────────────────────────────────────────────────────────────
  // POPUP OPEN / CLOSE
  // ────────────────────────────────────────────────────────────────────────────

  function openPopup(offer, items) {
    lastFocus = document.activeElement;

    var opacity = parseFloat(popupEl.dataset.overlayOpacity || '0.5');
    if (overlayEl) overlayEl.style.background = 'rgba(0,0,0,' + opacity + ')';

    if (panelEl) {
      panelEl.style.maxHeight = maxHeightVh + 'vh';
      if (window.innerWidth <= mobileBreakpoint) {
        panelEl.style.maxHeight = '100dvh';
      }
    }

    var title    = offer.title    || (config.defaults && config.defaults.title)    || '';
    var subtitle = offer.subtitle || (config.defaults && config.defaults.subtitle) || '';
    var contText = offer.continue_button_text || (config.defaults && config.defaults.continue_button_text) || 'CONTINUE';

    if (titleEl) titleEl.textContent = title;
    if (subtitleEl) {
      subtitleEl.textContent = subtitle;
      subtitleEl.hidden = !subtitle;
    }
    if (continueBtn) continueBtn.textContent = contText;

    if (itemsContainerEl) {
      itemsContainerEl.innerHTML = '';
      items.forEach(function (item) {
        itemsContainerEl.appendChild(buildItemRow(item));
      });
    }

    popupEl.hidden = false;
    popupEl.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';

    trapFocus(popupEl);

    var closeBtn = popupEl.querySelector('[data-f3-popup-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closePopup() {
    popupEl.hidden = true;
    popupEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    releaseFocus();
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); lastFocus = null; }
  }

  // ────────────────────────────────────────────────────────────────────────────
  // ITEM ROW BUILDER
  // ────────────────────────────────────────────────────────────────────────────

  function buildItemRow(item) {
    var defaultVariant = item.variants.find(function (v) { return v.id === item.default_variant_id; })
      || item.variants.find(function (v) { return v.available; })
      || item.variants[0];

    var hasOptions = item.options && item.options.length > 0
      && !(item.options.length === 1
           && item.options[0].name === 'Title'
           && item.options[0].values.length === 1
           && item.options[0].values[0] === 'Default Title');

    var row = document.createElement('div');
    row.className = 'f3-popup-item';
    row.setAttribute('role', 'listitem');
    row.setAttribute('data-product-id', item.product_id);
    row.setAttribute('data-variants', JSON.stringify(item.variants));

    // Image
    var imgWrap = document.createElement('div');
    imgWrap.className = 'f3-popup-item__image-wrap';
    if (item.featured_image) {
      var img = document.createElement('img');
      img.className = 'f3-popup-item__image';
      img.setAttribute('data-f3-popup-item-image', '');
      img.src = item.featured_image;
      img.alt = item.product_title || '';
      img.loading = 'lazy';
      imgWrap.appendChild(img);
    }
    row.appendChild(imgWrap);

    // Body
    var body = document.createElement('div');
    body.className = 'f3-popup-item__body';

    var titleLink = document.createElement('a');
    titleLink.className = 'f3-popup-item__title';
    titleLink.href = '/products/' + item.product_handle;
    titleLink.textContent = item.product_title || '';
    body.appendChild(titleLink);

    // Price row
    var priceRow = document.createElement('div');
    priceRow.className = 'f3-popup-item__price-row';

    var priceEl = document.createElement('span');
    priceEl.className = 'f3-popup-item__price';
    priceEl.setAttribute('data-f3-popup-price', '');
    priceEl.textContent = formatMoney(defaultVariant.price);
    priceRow.appendChild(priceEl);

    var compareEl = document.createElement('span');
    compareEl.className = 'f3-popup-item__compare-price';
    compareEl.setAttribute('data-f3-popup-compare', '');
    if (defaultVariant.compare_at_price && defaultVariant.compare_at_price > defaultVariant.price) {
      compareEl.textContent = formatMoney(defaultVariant.compare_at_price);
    } else {
      compareEl.hidden = true;
    }
    priceRow.appendChild(compareEl);

    body.appendChild(priceRow);

    // Badge
    if (item.badge_text) {
      var badge = document.createElement('div');
      badge.className = 'f3-popup-item__badge';
      badge.textContent = item.badge_text;
      body.appendChild(badge);
    }

    // Controls row: variant select + qty stepper + ADD
    var controls = document.createElement('div');
    controls.className = 'f3-popup-item__controls';

    if (hasOptions) {
      var select = document.createElement('select');
      select.className = 'f3-popup-item__variant-select f3-popup-variant-select';
      select.setAttribute('aria-label', 'Select variant');
      item.variants.forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.title;
        if (!v.available) opt.disabled = true;
        if (v.id === defaultVariant.id) opt.selected = true;
        select.appendChild(opt);
      });
      controls.appendChild(select);
    }

    // Qty stepper
    var stepper = document.createElement('div');
    stepper.className = 'f3-popup-item__qty-stepper';

    var decrBtn = document.createElement('button');
    decrBtn.type = 'button';
    decrBtn.className = 'f3-popup-item__qty-btn';
    decrBtn.setAttribute('data-f3-popup-decrement', '');
    decrBtn.setAttribute('aria-label', 'Decrease quantity');
    decrBtn.textContent = '−';
    stepper.appendChild(decrBtn);

    var qtyInput = document.createElement('input');
    qtyInput.type = 'number';
    qtyInput.className = 'f3-popup-item__qty-input f3-popup-qty-input';
    qtyInput.min = '1';
    qtyInput.value = item.default_quantity || 1;
    qtyInput.setAttribute('inputmode', 'numeric');
    qtyInput.setAttribute('aria-label', 'Quantity');
    stepper.appendChild(qtyInput);

    var incrBtn = document.createElement('button');
    incrBtn.type = 'button';
    incrBtn.className = 'f3-popup-item__qty-btn';
    incrBtn.setAttribute('data-f3-popup-increment', '');
    incrBtn.setAttribute('aria-label', 'Increase quantity');
    incrBtn.textContent = '+';
    stepper.appendChild(incrBtn);

    controls.appendChild(stepper);

    // Add button
    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'f3-popup-item__add-btn f3-popup-add-btn';
    addBtn.setAttribute('data-f3-popup-add', '');
    addBtn.setAttribute('data-variant-id', defaultVariant.id);
    addBtn.setAttribute('aria-label', 'Add to cart');
    addBtn.setAttribute('aria-live', 'polite');
    if (!defaultVariant.available) {
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
    } else {
      addBtn.textContent = 'ADD';
    }
    controls.appendChild(addBtn);

    body.appendChild(controls);

    // Inline error placeholder
    var errorEl = document.createElement('div');
    errorEl.className = 'f3-popup-item__error';
    errorEl.setAttribute('aria-live', 'polite');
    errorEl.hidden = true;
    body.appendChild(errorEl);

    row.appendChild(body);
    return row;
  }

  // ────────────────────────────────────────────────────────────────────────────
  // EVENT DELEGATION on popupEl
  // ────────────────────────────────────────────────────────────────────────────

  popupEl.addEventListener('click', function (e) {
    if (e.target.closest('[data-f3-popup-close]') || e.target.closest('[data-f3-popup-continue]')) {
      proceedToCheckout();
      return;
    }
    if (e.target.matches('[data-f3-popup-overlay]')) {
      proceedToCheckout();
      return;
    }

    var row = e.target.closest('.f3-popup-item');
    if (!row) return;
    var input = row.querySelector('.f3-popup-qty-input');

    if (e.target.closest('[data-f3-popup-decrement]') && input) {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
      return;
    }
    if (e.target.closest('[data-f3-popup-increment]') && input) {
      input.value = parseInt(input.value, 10) + 1;
      return;
    }

    var addBtn = e.target.closest('[data-f3-popup-add]');
    if (!addBtn || addBtn.disabled || addBtn.classList.contains('is-added')) return;
    handleAdd(addBtn, row);
  });

  // Variant select → update price, image, add-btn availability
  popupEl.addEventListener('change', function (e) {
    var select = e.target.closest('.f3-popup-variant-select');
    if (!select) return;
    var row = select.closest('.f3-popup-item');
    if (!row) return;
    updateRowVariant(row, parseInt(select.value, 10));
  });

  // Qty input blur → clamp to [1, ...]
  popupEl.addEventListener('blur', function (e) {
    var input = e.target.closest('.f3-popup-qty-input');
    if (!input) return;
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < 1) input.value = 1;
  }, true);

  // ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !popupEl.hidden) proceedToCheckout();
  });

  // ────────────────────────────────────────────────────────────────────────────
  // VARIANT CHANGE
  // ────────────────────────────────────────────────────────────────────────────

  function updateRowVariant(row, variantId) {
    var variants;
    try { variants = JSON.parse(row.dataset.variants || '[]'); } catch (e) { variants = []; }
    var v = variants.find(function (x) { return x.id === variantId; });
    if (!v) return;

    var addBtn = row.querySelector('[data-f3-popup-add]');
    if (addBtn) {
      addBtn.dataset.variantId = v.id;
      if (v.available) {
        addBtn.disabled = false;
        if (!addBtn.classList.contains('is-added')) addBtn.textContent = 'ADD';
      } else {
        addBtn.disabled = true;
        if (!addBtn.classList.contains('is-added')) addBtn.textContent = 'Unavailable';
      }
    }

    var priceEl = row.querySelector('[data-f3-popup-price]');
    if (priceEl) priceEl.textContent = formatMoney(v.price);

    var compareEl = row.querySelector('[data-f3-popup-compare]');
    if (compareEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compareEl.textContent = formatMoney(v.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (v.featured_image) {
      var imgEl = row.querySelector('[data-f3-popup-item-image]');
      if (imgEl) imgEl.src = v.featured_image;
    }
  }

  // ────────────────────────────────────────────────────────────────────────────
  // ADD TO CART
  // ────────────────────────────────────────────────────────────────────────────

  function handleAdd(addBtn, row) {
    var select    = row.querySelector('.f3-popup-variant-select');
    var variantId = select ? parseInt(select.value, 10) : parseInt(addBtn.dataset.variantId, 10);
    var qtyInput  = row.querySelector('.f3-popup-qty-input');
    var qty       = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;

    if (!variantId) return;

    addBtn.classList.add('is-loading');
    addBtn.textContent = '…';
    addBtn.disabled = true;

    var errorEl = row.querySelector('.f3-popup-item__error');
    if (errorEl) errorEl.hidden = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Error'); });
        return r.json();
      })
      .then(function () {
        addBtn.classList.remove('is-loading');
        addBtn.classList.add('is-added');
        addBtn.textContent = 'Added ✓';
        if (window.F3CartDrawer && typeof window.F3CartDrawer.refresh === 'function') {
          window.F3CartDrawer.refresh();
        }
      })
      .catch(function (err) {
        addBtn.classList.remove('is-loading');
        addBtn.disabled = false;
        addBtn.textContent = 'ADD';
        if (errorEl) {
          errorEl.textContent = err.message || 'Unavailable — try another option';
          errorEl.hidden = false;
        }
      });
  }

  // ────────────────────────────────────────────────────────────────────────────
  // CHECKOUT PROCEED
  // ────────────────────────────────────────────────────────────────────────────

  function proceedToCheckout() {
    closePopup();
    window.location.href = '/checkout';
  }

  // ────────────────────────────────────────────────────────────────────────────
  // FOCUS TRAP
  // ────────────────────────────────────────────────────────────────────────────

  function trapFocus(el) {
    var focusable = getFocusable(el);
    if (focusable.length) focusable[0].focus();
    _trapHandler = function (e) {
      if (e.key !== 'Tab') return;
      var f = getFocusable(el);
      if (!f.length) return;
      if (e.shiftKey) {
        if (document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      } else {
        if (document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    };
    document.addEventListener('keydown', _trapHandler);
  }

  function releaseFocus() {
    if (_trapHandler) { document.removeEventListener('keydown', _trapHandler); _trapHandler = null; }
  }

  function getFocusable(el) {
    return Array.from(el.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])'
    )).filter(function (n) { return n.offsetParent !== null; });
  }

  // ────────────────────────────────────────────────────────────────────────────
  // MONEY FORMATTER
  // ────────────────────────────────────────────────────────────────────────────

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        var fmt = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
        return window.Shopify.formatMoney(cents, fmt);
      } catch (e) { /* fall through */ }
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // ────────────────────────────────────────────────────────────────────────────
  // PUBLIC API — called by f3-cart-drawer.js after every cart mutation so
  // config.cart_state stays current without a full page reload.
  // ────────────────────────────────────────────────────────────────────────────
  window.F3CheckoutPopup = window.F3CheckoutPopup || {};

  window.F3CheckoutPopup.refreshCartState = function (sectionHtml) {
    if (!sectionHtml) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = sectionHtml;
    var freshDataEl = tmp.querySelector('#F3CheckoutPopupData');
    if (!freshDataEl) return;
    try {
      var freshConfig = JSON.parse(freshDataEl.textContent);
      if (freshConfig && freshConfig.cart_state) {
        config.cart_state = freshConfig.cart_state;
      }
    } catch (e) { /* ignore parse errors */ }
  };

})();
